<template>

<div id="" class="leftmenu newsarticle" v-if="page && !is_fetching_content">

    <router-link v-if="!lastRoute" :to="'/news'" class="lm-link lm-backbtn trigger-nav-back">
        Back
    </router-link>
    <a v-if="lastRoute" href="javascript:history.go(-1)" class="lm-link lm-backbtn trigger-nav-back">
        Back        
    </a>

	<h1 class="lm-h1">
        <span class="straight">
            News
        </span>
        <span class="styled">
            {{page.title}}
        </span>
    </h1>

	<br><br>
	<div class="text wysiwyg-content" v-if="page.text_col1" v-html="page.text_col1" @click="handleDynamicHtmlClicks($event)"></div>

	<br><br><br>

	<div id="admin-lmenu" v-if="false && loggedin_user">
            
        <router-link class="lm-link lvl1" to="/admin">
            Admin
        </router-link><br>

		<router-link class="lm-link lvl1" :to="'/admin/page/'+$store.state.loaded_page.id">
			Edit newsarticle
		</router-link><br>                 
                
    </div>

</div>

</template>
<script>
import mixins from '.././mixins.js'


export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		
	},

	data(){ return {                            
        
	}},


	computed: {

		page(){ return this.$store.state.loaded_page },

		lastRoute(){ return this.$store.state.route.previous[1] },
		
		show_admin_page_edit_btn(){

		},

	},

	methods: {

		

	},

	created(){
		
	},

	mounted(){

		
	
	},

}
</script>



// WEBPACK FOOTER //
// src/views/LeftMenuNewsarticle.vue